import { createRef, KeyboardEvent, PureComponent, RefObject } from "react";

import Elt from "./Elt";
import { char, num } from "./serialization";

import "./Solution.css"

interface SolutionProps {
  data: Record<num, char>,
  onChange: (num : string, letter : char) => boolean,
}

interface SolutionState {
  focussed : string;
}

class Solution extends PureComponent<SolutionProps, SolutionState> {
  public state = {
    focussed : "",
  };

  constructor(props : SolutionProps) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.setFocussed = this.setFocussed.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  handleChange(num : string, c : char) : boolean {
    return this.props.onChange(num, c);
  }

  setFocussed(num : string) {
    this.setState({focussed: num});
  }

  focusElt(num : string) {
    this.getRef(num).current?.focus();
  }

  // handle arrow keys.
  handleKeyDown(event : KeyboardEvent<HTMLDivElement>) : void {
    let focNum = Number.parseInt(this.state.focussed);
    if (Number.isNaN(focNum)) return;

    switch (event.key) {
    case "ArrowUp":
      if (focNum > 1)  focNum--;
      break;
    case "ArrowDown":
      if (focNum < 26) focNum++;
      break;
    }

    this.focusElt(focNum+"");
  }

  private myRefs : Record<string, RefObject<Elt>> = {};

  getRef(num : string) : RefObject<Elt> {
    let ref = this.myRefs[num];
    if (!ref) this.myRefs[num] = ref = createRef<Elt>();
    return ref;
  }

  render() {
    const elts = Object
      .entries(this.props.data)
      .flatMap(([num, letter]) => [
        <Elt coord={num} key={`key-${num}`} onFocus={this.setFocussed}>{num}</Elt>,
        <Elt coord={num} ref={this.getRef(num)} key={`value-${num}`} onChange={this.handleChange} onFocus={this.setFocussed}>{letter}</Elt>
      ])

    return (
      <div className={`Solution`} onKeyDown={this.handleKeyDown}>
        {elts}
      </div>
    );
  }
}

export default Solution